import './Lyrics.scss';
import LyricsIcon from '@mui/icons-material/Lyrics';


import { Link } from 'react-router-dom';

const Lyrics = ({ onClose }) => {
  return (
    <div className="vrat-modal-overlay" onClick={onClose}>
      <div className="vrat-modal-content" onClick={e => e.stopPropagation()}>
        <div className="vrat-container">
          <h2>Lyrics and Mantras</h2>
          <div className="vrat-grid">

            <Link to="/arati" className="vrat-item">
              <LyricsIcon className="icon" />
              <div><h4>Arati Samuha</h4></div>
            </Link>

           


          </div>
        </div>
      </div>
    </div>
  );
};

export default Lyrics;
